import React, { Component } from 'react';

class VesselComponent extends Component {
  render() {return <div>this is vessels component</div>}
}

export default VesselComponent;
